import { render, staticRenderFns } from "./GameVersion.vue?vue&type=template&id=48427562&scoped=true&"
import script from "./GameVersion.vue?vue&type=script&lang=ts&"
export * from "./GameVersion.vue?vue&type=script&lang=ts&"
import style0 from "./GameVersion.vue?vue&type=style&index=0&id=48427562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48427562",
  null
  
)

export default component.exports